export default __webpack_public_path__ + "static/media/Abyss Rings.6de5df21.mp4";